import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './PaymentSuccess.css';

const PaymentSuccess: React.FC = () => {
  return (
    <div className="payment-success-page">
      <Helmet>
        <title>Booking Confirmed | Cosmic Kavi</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://cosmickavi.com/payment-success" />
      </Helmet>
      <div className="payment-success-card">
        <div className="ps-icon">✨</div>
        <h1>Payment Received!</h1>
        <p className="ps-subtitle">
          Thank you for booking your Vedic astrology reading with Astrologer Kavitha Nandy.
        </p>

        <div className="ps-steps">
          <div className="ps-step">
            <span className="ps-step-num">1</span>
            <p>A payment confirmation has been sent to your email</p>
          </div>
          <div className="ps-step">
            <span className="ps-step-num">2</span>
            <p>Astrologer Kavitha Nandy will prepare your personalised birth chart</p>
          </div>
          <div className="ps-step">
            <span className="ps-step-num">3</span>
            <p>You will receive a secure download link via email after your appointment</p>
          </div>
        </div>

        <p className="ps-contact">
          Questions? Email <a href="mailto:astrologerkavitha@gmail.com">astrologerkavitha@gmail.com</a> or WhatsApp <a href="https://wa.me/14252190869">+1 425-219-0869</a>
        </p>

        <Link to="/" className="ps-home-btn">Return to Home</Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
